import { FunctionComponent, ReactNode, useMemo } from 'react';
import NewHeaderLogoHeader from './LogoHeader';

export interface MainLayoutHeaderProps {
  Logo?: FunctionComponent;
  Append?: ReactNode;
  border?: boolean;
  sticky?: boolean;
  hideMobile?: boolean;
  showSidebar?: boolean;
}

const MainLayoutHeader: React.FunctionComponent<MainLayoutHeaderProps> =
  function ({
    Logo = NewHeaderLogoHeader,
    Append = undefined,
    border = true,
    sticky = true,
    hideMobile = false,
    showSidebar = true,
  }) {
    const classNames = useMemo(
      () => ({
        wrapper: [
          hideMobile ? 'hidden md:flex' : 'flex md:hidden',
          'flex-col',
          sticky ? 'sticky top-0 z-[9998]' : '',
        ].join(' '),
        container: [
          'flex bg-neutral-000',
          border ? 'border-b border-neutral-300' : '',
        ].join(' '),
        content: [
          'flex flex-row w-full py-5.5 px-6 md:px-10 lg:px-15',
          showSidebar ? 'ml-auto max-w-240' : 'max-w-360 mx-auto',
        ].join(' '),
      }),
      [border, sticky, hideMobile, showSidebar],
    );

    return (
      <div className={classNames.wrapper}>
        <div className={classNames.container}>
          <div className={classNames.content}>
            <Logo />
          </div>
        </div>
        {Append}
      </div>
    );
  };

export default MainLayoutHeader;
